export interface AppConfiguration {
  api: {
    matchcenter: {
      readonly root: string;
      readonly key: string;
    };
    escenic: {
      readonly root: string;
      readonly section: string;
      readonly group: string;
    };
    wordpress: {
      readonly root: string;
      readonly api_key: string;
    };
    tvprogram: {
      readonly root: string;
    };
    bet: {
      readonly root: string;
    };
  };
  pollingRates: {
    readonly sportEvents: number;
    readonly liveMatches: number;
    readonly timeline: number;
    readonly stats: number;
    readonly lineups: number;
    readonly scores: number;
    readonly betData: number;
    readonly tables: number;
  };
}

/**
 * Returns the application configuration, including env variables.
 */
const getConfig = (): AppConfiguration => ({
  api: {
    matchcenter: {
      root: <string>process.env.REACT_APP_MATCHCENTER_API_ROOT,
      key: <string>process.env.REACT_APP_MATCHCENTER_API_KEY,
    },
    escenic: {
      root: <string>process.env.REACT_APP_ESCENIC_API_ROOT,
      section: <string>process.env.REACT_APP_ESCENIC_API_SECTION,
      group: <string>process.env.REACT_APP_ESCENIC_API_GROUP,
    },
    wordpress: {
      root: <string>process.env.REACT_APP_WORDPRESS_API_ROOT,
      api_key: <string>process.env.REACT_APP_WORDPRESS_API_KEY
    },
    tvprogram: {
      root: <string>process.env.REACT_APP_TVPROGRAM_API_ROOT,
    },
    bet: {
      root: <string>process.env.REACT_APP_BET_API_ROOT,
    },
  },
  pollingRates: {
    sportEvents: parseInt(<string>process.env.REACT_APP_SPORT_EVENTS_POLLING_RATE, 10) || 60000,
    liveMatches: parseInt(<string>process.env.REACT_APP_SPORT_LIVE_MATCH_POLLING_RATE, 10) || 5000,
    timeline:
      parseInt(<string>process.env.REACT_APP_SPORT_LIVE_MATCH_TIMELINE_POLLING_RATE, 10) || 5000,
    stats: parseInt(<string>process.env.REACT_APP_SPORT_LIVE_MATCH_STATS_POLLING_RATE, 10) || 5000,
    lineups:
      parseInt(<string>process.env.REACT_APP_SPORT_LIVE_MATCH_LINEUPS_POLLING_RATE, 10) || 5000,
    scores:
      parseInt(<string>process.env.REACT_APP_SPORT_LIVE_MATCH_SCORES_POLLING_RATE, 10) || 5000,
    betData:
      parseInt(<string>process.env.REACT_APP_SPORT_LIVE_MATCH_BETDATA_POLLING_RATE, 10) || 60000,
    tables:
      parseInt(<string>process.env.REACT_APP_SPORT_LIVE_MATCH_TABLES_POLLING_RATE, 10) || 5000,
  },
});

export default getConfig;
